// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import Student from "./Student";
// Constants
import { STUDENT_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Services
import { get, put, gen_link } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
import Filter from "./Filter";

const Students = () => {
    const permissions = usePermissions();
    const navigate = useNavigate();
    const spinService = SpinService();
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: "",
        queryFilters: "{}"
    });

    const [students, setStudents] = useState({
        entries: [],
        total_count: 0
    });

    const getStudents = async () => {
        spinService.on();
        const response = await get(EntityConstants.STUDENTS, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}&queryFilters=${filter.queryFilters}`);
        const data = await response.json();
        setStudents(data);
        spinService.off();
    };

    const onClose = () => {
        getStudents();
        setOpen(false);
        setOpenFilter(false);
    };

    const onSwitch = async (e) => {
        spinService.on();
        const response = await put(EntityConstants.STUDENTS + `/${e.id}`, { student: { status: !e.status } });
        if ([200, 201].indexOf(response.status) > -1) {
            getStudents();
        }
        spinService.off();
    };

    const downloadStudentsHandle = () => {
        const link = document.createElement('a');
        link.href = gen_link(EntityConstants.STUDENTS_DOWNLOAD);
        link.target = '_blank';
        link.click();
    };

    useEffect(() => {
        if (permissions.has(PermissionConstants.STUDENT_VIEW)) {
            getStudents();
        } else {
            navigate("/")
        }
    }, [filter]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Students
                    </Typography>
                    <div>
                        {permissions.has(PermissionConstants.STUDENT_CREATE) &&
                            <Button
                                variant="contained"
                                startIcon={<Iconify icon="eva:plus-fill" />}
                                onClick={() => { setId(undefined); setOpen(true) }}
                            >
                                New Student
                            </Button>
                        }
                        &nbsp;&nbsp;
                        {permissions.has(PermissionConstants.STUDENT_DOWNLOAD) &&
                            <Button
                                variant="contained"
                                startIcon={<Iconify icon="typcn:download" />}
                                onClick={downloadStudentsHandle}
                            >
                                Download
                            </Button>
                        }
                    </div>
                </Stack>
                <Card>
                    <GoTable
                        tableHeads={STUDENT_TABLE_HEADS}
                        tableDatas={students.entries}
                        totalCount={students.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter((prevState) => {
                            return {
                                ...prevState,
                                sort: filter.sort,
                                order: filter.order,
                                max: filter.max,
                                offset: filter.offset,
                                search: filter.search,
                            }
                        })}
                        onView={(row) => { setId(row.id); setOpen(true) }}
                        onSwitch={(e) => onSwitch(e)}
                        openFilter={() => setOpenFilter(true)}
                        customFilter={true}
                    />
                </Card>
            </Container>

            {
                permissions.has(PermissionConstants.STUDENT_VIEW) && open && <GoDrawer
                    minwidth="70%"
                    title="Student"
                    open={open}
                    onClose={() => onClose()}
                >
                    <Student id={id} onClose={() => onClose()} />
                </GoDrawer>
            }

            {
                openFilter && <Filter
                    queryFilters={filter.queryFilters}
                    openFilter={openFilter}
                    onClose={() => onClose()}
                    onFilters={(filterQuries) => setFilter((prevState) => { return { ...prevState, queryFilters: JSON.stringify(filterQuries) } })} />
            }

        </React.Fragment>
    );
}

export default Students;